import { accessOptions } from '@/domain/global.enum';

const menu = [
  {
    header: 'Apps',
    group: 'apps',
    options: [accessOptions.DASHBOARD],
    divider: true,
  },
  {
    header: 'Recepción',
    group: 'tickets',
    existItems: true,
    options: [accessOptions.GENERATE_TICKETS],
  },
  {
    header: 'Asesor',
    group: 'box',
    existItems: true,
    options: [accessOptions.BOX, accessOptions.RESERVATION],
  },
];

export default menu;
